import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection, ErrorHandler, inject, importProvidersFrom } from '@angular/core';
import { provideRouter, Router, NavigationEnd } from '@angular/router';
import * as Sentry from "@sentry/angular";
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideIcons } from 'app/providers/icons.providers';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { LoaderInterceptor } from 'app/interceptors/loader.interceptor';
import { jwtInterceptor } from 'app/interceptors/jwt.interceptor';
import { authInterceptor } from 'app/interceptors/auth.interceptor';

import { AnalyticsService } from './services/analytics.service';
import { MicrophoneCleanupService } from 'app/services/microphone-cleanup.service';

import { filter } from 'rxjs/operators';

import { OrientationService } from 'app/services/orientation.service';


// Firebase - Configuración para notificaciones push
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
	providers: [
		// Firebase: Inicialización de Firebase y servicio de mensajería para notificaciones push
		provideFirebaseApp(() => initializeApp(environment.firebase)),
		provideMessaging(() => getMessaging()),
        provideDatabase(() => getDatabase()),
   
		// Configuración de detección de cambios de Angular optimizada
		provideZoneChangeDetection({ eventCoalescing: true }),
		
		// Configuración de routing
		provideRouter(routes),
		
		// Animaciones optimizadas (modo 'noop' - sin operaciones, para mejor rendimiento)
		provideAnimationsAsync('noop'),
		
		// Interceptor HTTP para manejo de indicadores de carga
		provideHttpClient(withInterceptors([LoaderInterceptor])),
		
		// Proveedores personalizados para la aplicación
		provideIcons(),
		
		// Interceptores HTTP para autenticación y JWT
		provideHttpClient(withInterceptors([authInterceptor, jwtInterceptor])),
		
		// Integración con Sentry para monitoreo de errores
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler(),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => {},
			deps: [Sentry.TraceService],
			multi: true,
		},
		
		// Seguimiento de navegación para analytics
		{
			provide: 'ROUTE_ANALYTICS_TRACKER',
			useFactory: () => {
				const router = inject(Router);
				const analyticsService = inject(AnalyticsService);
				
				return router.events.pipe(
					filter(event => event instanceof NavigationEnd)
				).subscribe((event: any) => {
					analyticsService.trackPageView(event.urlAfterRedirects);
				});
			}
		},
		MicrophoneCleanupService,
		OrientationService
	]
};	